/**
 * Faculty Schedule
 */
import { z } from 'zod';
import {
  FacultyScheduleId,
  FacultyId,
  AcademicYear,
  TermId,
  UnixTimestamp,
} from '../types/branded';
import { ScheduleDaySchema } from '../types/enums';

export const FacultyScheduleBlockSchema = z.object({
  day: ScheduleDaySchema,
  period: z.number().int().positive().optional(),
  startMinute: z.number().int().min(0).max(1439),
  endMinute: z.number().int().min(1).max(1440),
  label: z.string().min(1).optional(),
  location: z.string().min(1).optional(),
  blockType: z.enum(['teaching', 'prep', 'duty']).optional(),
  gradeLabel: z.string().optional(),
  subjectLabel: z.string().optional(),
  room: z.string().optional(),
}).refine((value) => value.endMinute > value.startMinute, {
  message: 'endMinute must be > startMinute',
  path: ['endMinute'],
});
export type FacultyScheduleBlock = z.infer<typeof FacultyScheduleBlockSchema>;

export const FacultyScheduleExceptionSchema = z.object({
  date: UnixTimestamp,
  reason: z.string().min(1).optional(),
  cancelled: z.boolean().default(false),
  overrideBlocks: z.array(FacultyScheduleBlockSchema).default([]),
});
export type FacultyScheduleException = z.infer<typeof FacultyScheduleExceptionSchema>;

export const FacultyScheduleSchema = z.object({
  id: FacultyScheduleId,
  facultyId: FacultyId,
  academicYear: AcademicYear,
  termId: TermId.optional(),
  template: z.array(FacultyScheduleBlockSchema),
  exceptions: z.array(FacultyScheduleExceptionSchema).default([]),
  createdAt: UnixTimestamp,
  updatedAt: UnixTimestamp,
});
export type FacultySchedule = z.infer<typeof FacultyScheduleSchema>;
